import moment from "moment";
import styled from "styled-components";
import theme from "../../styles/theme";
import React, { useEffect, useState } from "react";
import { DesktopDatePicker, DesktopTimePicker } from "@mui/x-date-pickers";
import { Button } from "@mui/material";

const MainWrap = styled.div`
    // width: 26.5rem;
    width:100%;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    min-width: 26.5rem;
    // border-radius: 12px;
    // border: 1px solid ${theme.color.black[10]};
    // padding: 0.5rem;
`;
const TitleLine = styled.ul`
    list-style-type: none;
    padding:0;
    // padding: 0 0.4rem;
    margin:0;
    border-bottom:1px solid ${theme.color.black[20]};
    li {
        display: grid;
        grid-template-columns: 9rem 6rem 6rem;
        gap: 0.5rem;
        font-size: 1rem;
        line-height: 2rem;
        height: 2rem;
        span {
            text-align: center;
        }
    }
`;
const DescArea = styled.ul`
    list-style-type: none;
    width: 100%;
    height: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    cursor: pointer;
    overflow: auto;
    .descLiItem  {
        width: 100%;
        gap: 0.8rem;
        font-size: 1rem;
        // line-height: 1rem;
        // height: 2rem;
        // border-radius: 12px;
        border-bottom: 1px solid ${theme.color.black[10]};
        padding: 0.5rem 0;
        display: grid;
        grid-template-columns: 9rem 6rem 6rem 4rem;
        gap: 0.5rem;
        // div {
        //     width: 100%;
            
        //     span:nth-child(1) {
        //         text-align: right;
        //     }
        // }
    }
    // .descLiItem:nth-child(even){
    //     background: rgba(0, 0, 0, 0.04);
    // }
`;

const TimeTable = ({name,list:target, titleFlag, time_unit, handleAddClick, handleModClick}) => {

    const [list, setList] = useState();

    useEffect(()=>{
        setList(target);
    },[target])

    return (
        <MainWrap>
            {titleFlag !== false  && 
            <TitleLine>
                <li>
                    <span style={{textAlign:'center'}}>{name}</span>
                    <span style={{textAlign:'center'}}>시작시간</span>
                    <span style={{textAlign:'center'}}>종료시간</span>
                </li>
            </TitleLine>
            }
            <DescArea style={{height:'calc(100% - '+(titleFlag===true?'4.5rem':'0rem')+')',maxHeight:'calc(100% - '+(titleFlag===true?'4.5rem':'0rem')+')'}}>
                {list && list.length > 0 &&
                    list.map((item,index)=>(
                        <ListItem index={index} time_unit={time_unit} item={item} handleButtonClick={handleModClick} />
                    ))
                }
                <ListItem time_unit={time_unit} handleButtonClick={handleAddClick} />
            </DescArea>
        </MainWrap>
    )
}

const ListItem = ({item, handleButtonClick, time_unit}) => {

    const [target, setTarget] = useState();

    useEffect(()=>{
        setTarget(item)
    },[item])

    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleClick = () => {
        handleButtonClick && handleButtonClick(target)
    }


    return (
        <React.Fragment>
            <li className={'descLiItem'}>
                <DesktopDatePicker
                    id='sdate'
                    format='YYYY-MM-DD'
                    // size='small'
                    slotProps={{ textField: { size: 'small'} }}
                    value={target && moment(target.sdate)}
                    onChange={(value)=>handleValueChange('sdate', value.format('YYYY-MM-DD'))}
                />
                <DesktopTimePicker
                    id='stime'
                    format='HH:mm'
                    timeSteps={{minutes:time_unit/60}}
                    slotProps={{ textField: { size: 'small'} }}
                    value={(target && target.stime) ? moment(target.sdate +' '+target.stime):undefined}
                    onChange={(value)=>handleValueChange('stime', value.format('HH:mm'))}
                />
                <DesktopTimePicker
                    id='etime'
                    format='HH:mm'
                    timeSteps={{minutes:time_unit/60}}
                    slotProps={{ textField: { size: 'small'} }}
                    value={(target && target.etime) ? moment(target.sdate +' '+target.etime):undefined}
                    onChange={(value)=>handleValueChange('etime', value.format('HH:mm'))}
                />
                <Button variant='contained' onClick={handleClick}>{(target && target.seq) ? '수정' : '추가'}</Button>
            </li>
        </React.Fragment>
    )
}

export default TimeTable;